module.exports = __webpack_public_path__ + "frontend-assets/img/dual-coupon.279ccdae.png";